import React,{ useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import './report.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Dropdown } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { var_api } from "../../constant";
import axios from "axios";
import jsPDF from "jspdf";
import Select from 'react-select';
import Swal from "sweetalert2";
import Pagination from 'react-js-pagination';
import Loader from "../Loader";
import { Button, ModalHeader, ModalBody, ModalFooter, Card, CardImg, CardText, CardBody,CardHeader,
    CardTitle, CardSubtitle} from 'react-bootstrap';


const SbReport = () => {

  const formatDate = (date) => {
    const d = new Date(date);
    const day = (`0${d.getDate()}`).slice(-2);
    const month = (`0${d.getMonth() + 1}`).slice(-2);
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
};
    const history = useHistory();
    const shopname = localStorage.getItem('shopName');
    const today = new Date();
    const [viewMod, setViewMod] = useState(false);
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1; // Months are zero-based, so add 1
    const currentDay = today.getDate();
    const [todayIncome, setTodayIncome] = useState(null);
    const [monthlyIncome, setMonthlyIncome] = useState(null);
    const [ orders, setOrders ] = useState([]);
    const [buttonVisible, setButtonVisible] = useState(true);
    const [isLogin, setIsLogin] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; 
    const [totalItems, setTotalItems] = useState(0);
    const [startIndex, setStartIndex] = useState(0);
    const [ searchQuery,setSearchQuery] = useState('');
    const [servicesHistorysummary, setServiceshistorysummary] = useState([]);
    const [servicesHistory, setServiceshistory] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [fromDate, setFromDate] = useState(formatDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1)));
    const [toDate, setToDate] = useState(formatDate(new Date()));
    const [data, setData] = useState([]);
    const [selectedTask, setSelectedTask] = useState(null);
    const [paginatedServicesHistory, setPaginatedServicesHistory] = useState([]); 
    const formatDatee = (date) => {
      return date.toISOString().split('T')[0]; // Returns date in YYYY-MM-DD format
    }; 
    const todaysss = formatDatee(new Date());

    //Navigate to home page
    const handleGoTOHome = () => {
        history.push('/sb-home');
    };


   //to handle view the report
   const handleViewReport = (task) => {
    setSelectedTask(task);
    setViewMod(true);
};

    //close the modal
    const handleCloseMod = () => setViewMod(false);

// Fetch data on component mount or when fromDate/toDate changes
useEffect(() => {
  if (selectedEmployee) {
    fetchservicesHistorysummary(selectedEmployee, fromDate, toDate);
    fetchservicesHistory(selectedEmployee, fromDate, toDate);
    setCurrentPage(1);
  }
}, [selectedEmployee, fromDate, toDate]);

useEffect(() => {
  getEmployees(); 
}, []);

// Recalculate paginated data whenever currentPage or servicesHistory changes
useEffect(() => {
  if (servicesHistory.length > 0) {
    const startIndexCalc = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndexCalc + itemsPerPage;
    const paginatedData = servicesHistory.slice(startIndexCalc, endIndex);  // Slice for the current page
    setPaginatedServicesHistory(paginatedData);  // Display only the paginated data
  } else {
    setPaginatedServicesHistory([]);  // Clear paginated data when servicesHistory is empty
  }
}, [currentPage, servicesHistory]);

  const getEmployees = () => {
    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `${token}`
    };
    setIsLogin(true);
    axios.get(`${var_api}/api/employee/shop-emp-details`, { headers })
        .then((response) => {
            const employeeData = response.data;
            const employeeNames = employeeData.map(employee => ({
              label: employee.name,
              value: employee.id
          }));
          setEmployees(employeeNames);
          setIsLogin(false);
        })
        .catch((error) => {
            console.error('Error:', error);
            if (error.response && error.response.status === 401) {
              history.push('/signin');
          }
            // Handle error
        });
};
  
  const fetchservicesHistorysummary = async (employeeId, fromDate, toDate) => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    try {
        const response = await axios.get(`${var_api}/api/service-history-summary/${employeeId}/${fromDate}/${toDate}`, {
            headers: {
                'Authorization': `${token}`
            }
        });
        setServiceshistorysummary(response.data);
        
        setIsLogin(false);
    } catch (error) {
        setServiceshistorysummary([]);
        if (error.response && error.response.status === 401) {
          history.push('/signin');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error.response?.data?.error || 'Something went wrong!',
            confirmButtonColor: '#007500',
          });
        }
    }
  };

  const fetchservicesHistory = async (employeeId, fromDate, toDate) => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    try {
      const response = await axios.get(`${var_api}/api/service-history/${employeeId}/${fromDate}/${toDate}`, {
        headers: {
          Authorization: `${token}`,
        },
      });
  
      const historylist = response.data;
      
      if (historylist.length > 0) {
        setServiceshistory(historylist);  // Save the entire history
        setTotalItems(historylist.length); // Set total items for pagination
      } else {
        console.log('No data found.');
        setServiceshistory([]);
        setTotalItems(0);
      }
      setIsLogin(false);
    } catch (error) {
      setServiceshistory([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    }
  };
  

  const handleEmployeeSelectChange = (selectedOption) => {
    setSelectedEmployee(selectedOption.value);
    fetchservicesHistorysummary(selectedOption.value, fromDate, toDate);
    fetchservicesHistory(selectedOption.value, fromDate, toDate); // Pass the employee ID to the getLeavelist function
};

function calculateTotalTime(startTime, stopTime) {
    const start = new Date(`1970-01-01T${startTime}Z`);
    const stop = new Date(`1970-01-01T${stopTime}Z`);
    const diffMs = stop - start;
    const diffMins = Math.floor(diffMs / 60000); // Convert ms to minutes
    return diffMins;
}

const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

const { name, confirm_booking_count, room_service_count, seat_service_count, total_working_time } = servicesHistorysummary;

// const totalWorkingHours = Math.floor(total_working_time / 60);
// const totalWorkingMinutes = total_working_time % 60;

 // Function to convert minutes to hours and minutes
 const convertMinutesToHours = (minutes) => {
  if (!minutes && minutes == 0) return "0h 0m"; 
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (hours > 0) {
    return `${hours} hrs ${remainingMinutes} mins`;
  } else {
    return `${remainingMinutes} mins`;
  }
};
function getServiceStatus(status) {
  switch (status) {
    case 0:
      return "Upcoming";
    case 1:
      return "In Progress";
    case 2:
      return "Completed";
    default:
      return "Unknown";
  }
};


function formatTimeTo12Hours(timeString) {
  if (!timeString) return '';
  const [hours, minutes] = timeString.split(':');
  let period = 'AM';
  let hour = parseInt(hours, 10);

  if (hour === 0) {
    hour = 12;
  } else if (hour === 12) {
    period = 'PM';
  } else if (hour > 12) {
    hour -= 12;
    period = 'PM';
  }

  return `${hour}:${minutes} ${period}`;
}


    return (
        <>
        {isLogin && <Loader />} 
    <div id="firdiv" style={{ backgroundColor: "white"}}>
        <nav className="navbar navbar-expand navbar-light py-2 sticky-top" style={{boxShadow: "0px 0px 1px 0px black",backgroundColor:"rgba(103, 120, 95)",border:"none",padding:"10px"}} >
            <h3 style={{textAlign:"center",color:"white"}} id="kifo"><i class="bi bi-clipboard-data-fill"></i>{" "}Service Reports</h3>
            <button className="btn" id="sbhombug" onClick={handleGoTOHome}><i class="bi bi-house"></i> Go to home</button>
        </nav>
        <br/>
        <div style={{padding:"15px"}}>


            <div style={{display: "flex", justifyContent: "space-between",maxWidth:"1100px",margin:"auto"}}>
            <div style={{ margin: "auto", width: "60%" }}>
  <div style={{ display: 'flex', alignItems: 'center', gap: "5px" }}>
    <label style={{fontWeight:"bolder",fontFamily:"serif",color: "rgba(103, 120, 95)"}}>Beautician: </label>
    <Select
            options={employees}
            value={employees.find(emp => emp.value === selectedEmployee)}
            onChange={handleEmployeeSelectChange}
            placeholder="Select an employee"
            isSearchable={true}
            styles={{
                menu: (provided) => ({
                    ...provided,
                    zIndex: 9999, // Ensure the dropdown is displayed above other elements
                    width: "300px"
                })
            }}
        />
    {/* <i className="bi bi-calendar text-primary" style={{ marginLeft: '5px', fontSize: "20px" }} ></i> */}
    
    <div className="card" style={{width:"auto",margin:"0px",height:"auto", borderRadius:"10px"}}>
        <div className="card-body">
            <div className="row">
                <div className="col">
                <label style={{color: "rgba(103, 120, 95)"}}>From Date:</label>
                <input type="date" placeholder="From time" 
                value={fromDate.split('-').reverse().join('-')}
                // max={todaysss} 
                onChange={(e) => setFromDate(e.target.value.split('-').reverse().join('-'))}/>{" "}
                </div>
                <div className="col">
                <label style={{color: "rgba(103, 120, 95)"}}>To Date:</label><br/>
                <input type="date" placeholder="To time" 
                value={toDate.split('-').reverse().join('-')}
                // min={todaysss}
                onChange={(e) => setToDate(e.target.value.split('-').reverse().join('-'))}/>
                </div>
            </div>
        </div>
    </div>
  </div>
</div>

{/* <div className="card " style={{ width: '350px', height:'auto',margin:"0px auto",backgroundColor:"white !important"}}>
    <div className="card-header" style={{textAlign:"center",fontWeight:"bolder",color: "rgba(103, 120, 95)"}}>Report Summary<br/><span style={{fontSize:"14px",color: "black"}}>01-04-2024 to 05-04-2024</span></div>
    <div className="card-body" style={{padding:"10px",backgroundColor:"white", lineHeight:"8px"}}>
        <h6 style={{color: "rgba(103, 120, 95)",fontFamily:"serif",fontWeight:"bolder"}}>Beautician: <b style={{color:"black"}}>Kalpana</b> </h6>
        <p style={{color: "rgba(103, 120, 95)",fontWeight:"bolder",fontFamily:"serif"}}>Tasks Completed: <b style={{color:"black"}}>20</b><span style={{color: "rgba(103, 120, 95)",fontWeight:"bolder",fontFamily:"serif", float:"right"}}>Duration: <b style={{color:"black"}}>10hrs 30mins</b></span></p>
        <p style={{color: "rgba(103, 120, 95)",fontWeight:"bolder",fontFamily:"serif"}}>Seat Sittings: <b style={{color:"black"}}>3</b><span style={{color: "rgba(103, 120, 95)",fontWeight:"bolder",fontFamily:"serif", float:"right"}}>Room Sittings: <b style={{color:"black"}}>4</b></span></p>   
    </div>
</div> */}
 <div className="card" style={{ width: '350px', height: 'auto', margin: '0px auto', backgroundColor: 'white' }}>
            <div className="card-header" style={{ textAlign: 'center', fontWeight: 'bolder', color: 'rgba(103, 120, 95)' }}>
                Report Summary<br />
                <span style={{ fontSize: '14px', color: 'black' }}>{fromDate} to {toDate}</span>
            </div>
            <div className="card-body" style={{ padding: '10px', backgroundColor: 'white', lineHeight: '8px' }}>
                <h6 style={{ color: 'rgba(103, 120, 95)', fontFamily: 'serif', fontWeight: 'bolder' }}>Beautician: <b style={{ color: 'black' }}>{name}</b></h6>
                <p style={{ color: 'rgba(103, 120, 95)', fontWeight: 'bolder', fontFamily: 'serif' }}>Assigned Task: <b style={{ color: 'black' }}>{confirm_booking_count}</b>
                    <span style={{ color: 'rgba(103, 120, 95)', fontWeight: 'bolder', fontFamily: 'serif', float: 'right' }}>Duration: <b style={{ color: 'black' }}>{total_working_time == 0 ? 0 : convertMinutesToHours(total_working_time)}</b></span>
                </p>
                <p style={{ color: 'rgba(103, 120, 95)', fontWeight: 'bolder', fontFamily: 'serif' }}>Seat Sittings: <b style={{ color: 'black' }}>{seat_service_count}</b>
                    <span style={{ color: 'rgba(103, 120, 95)', fontWeight: 'bolder', fontFamily: 'serif', float: 'right' }}>Room Sittings: <b style={{ color: 'black' }}>{room_service_count}</b></span>
                </p>
            </div>
        </div>
            </div>

            <br/>
        
<div className="card" style={{height:"500px",borderRadius:"20px"}}>
    <div className="card-body">
    <div className="table-container" style={{ height: "400px", overflowX: 'auto', overflowY: 'scroll' }}>
                <table class="table table-hover small-first-col" style={{ border: "none", borderColor: "grey", width: "95%", margin: "auto" ,height:"50%"}}>
                    <thead>
                        <tr style={{ fontWeight: "bolder" }}>
                            <th scope="col">S.No</th>
                            <th scope="col">Date</th>
                            {/* <th scope="col">Slot Time</th> */}
                            <th scope="col">Customer</th>
                            <th scope="col">Mobile</th>
                            {/* <th scope="col">Sitting Type</th>
                            <th scope="col">Room/Seat Name</th> */}
                            {/* <th scope="col">Start Time-End Time</th>
                            <th scope="col">Time Taken</th> */}
                            <th scope='col'>Action</th>
                        </tr>
                    </thead>
                    <tbody class="body-half-screen">
                       
                    {paginatedServicesHistory && paginatedServicesHistory.length > 0 ? (
                        paginatedServicesHistory.map((task, index) => {
                        // Calculate total time if not provided
                        // let totalTime = task.total_time;
                        // if (totalTime === 0) {
                        //     totalTime = calculateTotalTime(task.start_time, task.stop_time);
                        // }
                        return (
                            <tr key={task.employee_task_details_id} style={{ padding: "5px" }}>
                                <td scope="row">{(currentPage - 1) * itemsPerPage+index + 1}</td>
                                <td>{task.task_date}</td>
                                {/* <td>{task.start_time}</td> */}
                                <td>{task.customer_name}</td>
                                <td>{task.customer_mobile}</td>
                                {/* <td>{task.seat_names ? "Seat" : "Room"}</td>
                                <td>{task.seat_names ? task.seat_names : task.room_names}</td> */}
                                {/* <td>{task.start_time} - {task.stop_time}</td>
                                <td>{Math.floor(totalTime / 60)} hrs {totalTime % 60} mins</td> */}
                                <td><button className="btn btn-primary" onClick={() => handleViewReport(task)}><i className="bi bi-eye-fill" ></i></button></td>
                             </tr>
                            );
                            })
                        ): (
                                <tr>
                                  <td colSpan="7" className="text-center">No data available</td>
                                </tr>
                              )}              
                    </tbody>
                </table>
                <br />
            </div>
    </div>
    <div style={{marginRight:'20px'}}>
    <Pagination
    activePage={currentPage}
    itemsCountPerPage={itemsPerPage}
    totalItemsCount={totalItems} // Update to reflect total items for pagination
    pageRangeDisplayed={5}
    onChange={handlePageChange}
    itemClass="page-item"
    linkClass="page-link"
    innerClass="pagination justify-content-end"
    activeClass="active-pagination" // Custom class for the active pagination item
/>
</div>
</div>


        </div>
        <Modal className="temp" size="lg" show={viewMod} onHide={handleCloseMod} backdrop="static" keyboard={false}>
  <Modal.Header closeButton>
    <Modal.Title> SERVICE DETAILS</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ overflow: 'scroll' }}>
    {selectedTask && (
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ flex: 1 }}>
          <p><strong>Booking No:</strong> {selectedTask.order_id}</p>
          <p><strong>Date:</strong> {selectedTask.task_date}</p>
        </div>
        <div style={{ flex: 1 }}>
          <p><strong>Customer Name:</strong> {selectedTask.customer_name}</p>
          <p><strong>Mobile Number:</strong> {selectedTask.customer_mobile}</p>
        </div>
      </div>
    )}
     <div>
      <p><strong>Service Details:</strong></p>
      {selectedTask && selectedTask.services.map((service, index) => (
        <Card
        bg="light"
        key={selectedTask.id}
        text="dark"
        style={{ maxWidth: "45rem", height: "auto", border: "none", borderBottom: "1px solid black", borderRadius: "0px", marginTop: "10px" }}
        className="mb-2"
      >
        <div className="row g-0">
          <div className="col-md-4 p-3">
            <CardImg src={`${var_api}/${service.image}`} alt="Service image" style={{ borderRadius: "50px" }} />
          </div>
          <div className="col-md-8">
            <CardBody>
              <CardText>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ flex: 1 }}>
        <p><strong>Service Name:</strong>{service.service_name}</p>
                <p><strong>Room Name:</strong> {service.name}</p>
                <p><strong>Service Cost:</strong> {service.service_cost} $</p>
        </div>
        <div style={{ flex: 1 }}>
        <p><strong>Start Time:</strong> {formatTimeTo12Hours(service.start_time)}</p>
                <p><strong>End Time:</strong> {formatTimeTo12Hours(service.end_time)}</p>
                <p><strong>Service Duration:</strong> {convertMinutesToHours(service.service_duration)}</p>
                <p><strong>Service Status:</strong> {getServiceStatus(service.service_status)}</p>

        </div>
      </div>
              </CardText>
            </CardBody>
          </div>
        </div>
      </Card>
      ))}
    </div>
  </Modal.Body>
</Modal>

 
        </div>

        </>
  )
}





export default SbReport;